import styled from 'styled-components';
import css from '@styled-system/css';
import {compose, color, space, flex, layout } from 'styled-system';

export const Card = styled.div`
  ${css({
  color: 'cardText',
  backgroundColor: 'cardBackground',
})}
  padding: 1em;
  margin-bottom: 1em;
  width: 100%;
  max-width: 800px;
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  ${compose(color,space, flex, layout)}
  
`